export enum Fields {
  NAME = 'name',
  JOB = 'job_form',
}
